import apiClient from '../client'
import type { PageResponse } from '../types'
import type { UserResponse, UserCreateRequest, UserUpdateRequest } from './types'

export const usersApi = {
  list(params?: {
    userDisplayId?: string
    loginUserId?: string
    loginId?: string
    name?: string
    department?: string
    email?: string
    role?: string
    status?: string
    municipalityId?: number
    sortBy?: string
    order?: 'ASC' | 'DESC'
    page?: number
    size?: number
  }) {
    return apiClient.get<PageResponse<UserResponse>>('/api/users', { params })
  },

  getById(id: number) {
    return apiClient.get<UserResponse>(`/api/users/${id}`)
  },

  create(data: UserCreateRequest) {
    return apiClient.post<UserResponse>('/api/users', data, { _suppressToastOnFieldErrors: true })
  },

  update(id: number, data: UserUpdateRequest) {
    return apiClient.put<UserResponse>(`/api/users/${id}`, data, { _suppressToastOnFieldErrors: true })
  },

  unlock(id: number) {
    return apiClient.post<{ message: string }>(`/api/users/${id}/unlock`)
  },
}
